module.exports = __webpack_public_path__ + "img/b_mtn@2x.906c1c7d.png";